module.exports = __webpack_public_path__ + "static/media/footerfb.92761773.webp";